module.exports = __webpack_public_path__ + "first-200_glossy_number.jpg?0df2953f25db8083a0c10987ae7f9d3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_glossy_number.jpg
// module id = 484
// module chunks = 0